if (!customElements.get("gallery-video")) {
    customElements.define(
      "gallery-video",
      class GalleryVideo extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.videoContainer = this.querySelector('.wt-product__thumbnail-video')
            this.video = this.videoContainer.querySelector('video')
            if(!this.videoContainer || !this.video) return

            this.iconContainer = this.querySelector('.wt-product__thumbnail-video__gallery-video-icon');
            this.icons = this.iconContainer.querySelectorAll('svg')
            this.playIcon = this.icons[0];
            this.pauseIcon = this.icons[1];
            this.handleToggleVideoStatus = this.handleToggleVideoStatus.bind(this)

            
            this.videoContainer.addEventListener('click', this.handleToggleVideoStatus)
        }
        
        handleToggleVideoStatus() {
            const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
            const isPlaying = isVideoPlaying(this.video)
            if(isPlaying){
                this.pauseIcon.classList.toggle('hidden', !isPlaying)
                this.playIcon.classList.toggle('hidden', isPlaying)
                this.video.pause();
            } else{
                this.pauseIcon.classList.toggle('hidden', !isPlaying)
                this.playIcon.classList.toggle('hidden', isPlaying)
                this.video.play();
            }
        }
  
        disconnectedCallback() {
          this.videoContainer.removeEventListener('click', this.handleToggleVideoStatus)
        }

      },
    );
  }
  